import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  textCenter: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: 20
  },
  imageMaintain: {
    width: 300,
    height: 300,
    objectFit: 'cover'
  },
  center: {
    textAlign: 'center'
  },
  maintainCnt: {
    textAlign: 'left',
    fontSize: 14,
    margin: '20px 0px'
  }
});

const enhancer = compose(
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const smsAuth = enhancer(({ classes }) => {
  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.center}>
        <img
          src="/images/gochi_logo_print.png"
          alt="The website under maintenance"
          width="100%"
          className={classes.imageMaintain}
        />

        <div className={classes.maintainCnt}>
          エラーが発生しました。時間をおいてお試しください。
          {/* ただいまシステムに内部の構成変更に伴うメンテナンスのため、一時的にサービスの機能を全て停止しております。大変ご不便をおかけいたしますが、今しばらくお待ちください。
          <br />
          <br />
          <b>【メンテナンス作業予定日時】</b>
          <br />
          2021年4月15日（木）
          <b>08:00 ~ 11:30</b>
          <br />
          ※メンテナンス作業が終了次第公開いたします。
          <br />
          <br />
          <b>【お問い合わせ】</b>
          <br />
          ユーザー様
          <br />
          <a
            className="text-green"
            target="_blank"
            rel="noopener noreferrer"
            href="https://share.hsforms.com/1VKsj-5igT1KiIHAjFgs-ZA4fbv9"
          >
            https://share.hsforms.com/1VKsj-5igT1KiIHAjFgs-ZA4fbv9
          </a>
          <br />
          <br />
          登録店舗様
          <br />
          <a
            className="text-green"
            target="_blank"
            rel="noopener noreferrer"
            href="https://share.hsforms.com/1cQs7-hA9RNmMqAoHF6tRZA4fbv9"
          >
            https://share.hsforms.com/1cQs7-hA9RNmMqAoHF6tRZA4fbv9
          </a> */}
        </div>
      </div>
    </Container>
  );
});

export default withRouter(withStyles(styles)(smsAuth));
